export const GoogleLogo = () => (
  <svg
    aria-labelledby='google-logo-title'
    fill='none'
    height='24'
    role='img'
    viewBox='0 0 24 24'
    width='24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title id='google-logo-title'>Google logo</title>
    <g clipPath='url(#clip0_11194_5348)'>
      <path
        d='M8.36104 0.789921C5.96307 1.6218 3.89506 3.20073 2.46077 5.2948C1.02649 7.38887 0.301526 9.88769 0.392371 12.4242C0.483217 14.9608 1.38508 17.4013 2.9655 19.3874C4.54591 21.3735 6.72158 22.8005 9.17292 23.4587C11.1603 23.9715 13.2424 23.994 15.2404 23.5243C17.0504 23.1177 18.7238 22.2481 20.0967 21.0005C21.5256 19.6624 22.5627 17.9602 23.0967 16.0768C23.6768 14.0286 23.7801 11.8748 23.3985 9.78055H12.2385V14.4099H18.7017C18.5725 15.1483 18.2957 15.853 17.8878 16.4819C17.48 17.1107 16.9494 17.6509 16.3279 18.0699C15.5388 18.5922 14.6491 18.9435 13.716 19.1012C12.7803 19.2752 11.8205 19.2752 10.8848 19.1012C9.93633 18.9053 9.03912 18.5138 8.25042 17.9518C6.9832 17.0548 6.03168 15.7804 5.53167 14.3105C5.02333 12.8131 5.02333 11.1898 5.53167 9.69242C5.88759 8.64283 6.47598 7.68717 7.25292 6.8968C8.14203 5.9757 9.26766 5.31729 10.5063 4.99381C11.745 4.67034 13.0488 4.69429 14.2748 5.06305C15.2325 5.3569 16.1083 5.87057 16.8323 6.56305C17.561 5.83805 18.2885 5.11117 19.0148 4.38242C19.3898 3.99055 19.7985 3.61742 20.1679 3.21617C19.0627 2.18777 17.7654 1.38749 16.3504 0.861171C13.7736 -0.0744733 10.9541 -0.0996178 8.36104 0.789921Z'
        fill='white'
      />
      <path
        d='M8.3607 0.788879C10.9536 -0.101264 13.7731 -0.0767817 16.3501 0.858254C17.7653 1.38815 19.062 2.19228 20.1657 3.2245C19.7907 3.62575 19.3951 4.00075 19.0126 4.39075C18.2851 5.117 17.5582 5.84075 16.832 6.562C16.108 5.86953 15.2322 5.35586 14.2745 5.062C13.0489 4.69196 11.7451 4.66662 10.5061 4.98877C9.26712 5.31092 8.14079 5.96812 7.2507 6.88825C6.47377 7.67863 5.88538 8.63428 5.52945 9.68388L1.64258 6.6745C3.03384 3.91556 5.44273 1.80517 8.3607 0.788879Z'
        fill='#E33629'
      />
      <path
        d='M0.611401 9.65703C0.820163 8.6216 1.16701 7.61889 1.64265 6.67578L5.52953 9.69266C5.02119 11.1901 5.02119 12.8134 5.52953 14.3108C4.23453 15.3108 2.9389 16.3158 1.64265 17.3258C0.452308 14.9564 0.0892746 12.2567 0.611401 9.65703Z'
        fill='#F8BD00'
      />
      <path
        d='M12.2381 9.77734H23.3981C23.7797 11.8716 23.6764 14.0254 23.0963 16.0736C22.5623 17.957 21.5252 19.6592 20.0963 20.9973C18.8419 20.0186 17.5819 19.0473 16.3275 18.0686C16.9494 17.6491 17.4802 17.1084 17.8881 16.4788C18.296 15.8493 18.5726 15.1439 18.7013 14.4048H12.2381C12.2363 12.8636 12.2381 11.3205 12.2381 9.77734Z'
        fill='#587DBD'
      />
      <path
        d='M1.64062 17.3255C2.93687 16.3255 4.2325 15.3205 5.5275 14.3105C6.02851 15.7809 6.98138 17.0553 8.25 17.9518C9.04116 18.5112 9.9403 18.8995 10.89 19.0918C11.8257 19.2658 12.7855 19.2658 13.7213 19.0918C14.6543 18.9341 15.544 18.5828 16.3331 18.0605C17.5875 19.0393 18.8475 20.0105 20.1019 20.9893C18.7292 22.2375 17.0558 23.1078 15.2456 23.5149C13.2476 23.9846 11.1655 23.9621 9.17813 23.4493C7.60632 23.0296 6.13814 22.2898 4.86563 21.2762C3.51886 20.2067 2.41882 18.8591 1.64062 17.3255Z'
        fill='#319F43'
      />
    </g>
    <defs>
      <clipPath id='clip0_11194_5348'>
        <rect
          fill='white'
          height='24'
          width='24'
        />
      </clipPath>
    </defs>
  </svg>
);
